import React, { useEffect, useRef } from "react";
import { decodeHtml, decodeText } from "../../../utils/richText";
import { activateScripts } from "../rawHtml/RawHtml";

// Renders authored raw HTML as-is — deliberately unsanitized, the dialog warns that the
// field is for trusted authors (embeds, calculators, one-off marketing snippets). The
// delivery API HTML-escapes the stored value, so decode first (the FTL twin does the
// same via cmsfn.decode). Scripts injected through innerHTML are inert per HTML spec,
// so each one is re-created as a fresh element after mount to actually execute (RawHtml).
//
// The block only lives inside Grid columns, i.e. inside a .container. Dropping the inner
// .container therefore never made it wider than the column; "full width" now bleeds the
// block to the viewport edges (see _interactive-block.scss), and a highlighted background
// bleeds as well so the grey band runs edge to edge while the content stays contained.
const InteractiveBlock = ({ title, html, fullWidth, highlight }) => {
    const hostRef = useRef(null);
    const markup = decodeHtml(html);

    useEffect(() => {
        if (hostRef.current && markup) activateScripts(hostRef.current);
    }, [markup]);

    if (!markup) return null;

    // component-band: like a highlighted Grid, the grey band carries its own vertical padding and
    // the stack spacing moves inside it (see _content-rhythm.scss).
    const outerClass = ["interactive-block", fullWidth || highlight ? "interactive-block--bleed" : "", highlight ? "component-band bg-gray py-5" : ""]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={outerClass}>
            {title && (
                <div className="container">
                    <h2 className="mb-3">{decodeText(title)}</h2>
                </div>
            )}
            <div className={fullWidth ? undefined : "container"}>
                <div ref={hostRef} dangerouslySetInnerHTML={{ __html: markup }} />
            </div>
        </div>
    );
};

export default InteractiveBlock;